<template>
  <user-progress
    :allModules="progress.unit.count"
    :completedModules="progress.unit.completed"
    :displayValue="`${progress.unit.completed}/${progress.unit.count}`"
    :progress="Math.round((progress.unit.completed / progress.unit.count) * 100)"
    :progressLabel="trans('streams.dashboard.modules_completed')"
  >
    <chapters-progress
      :title="trans('courses.new_dashboard.missions')"
      :completed="progress.mission.completed"
      :total="progress.mission.count"
      :info-text="
        trans('courses.new_dashboard.have_completed_missions', {
          completedMissions_num: progress.mission.completed,
          totalMissions_num: progress.mission.count,
        })
      "
      type="star"
      :is-loading="isLoading"
    />

    <chapters-progress
      v-if="progress.webinar && progress.webinar.count"
      :title="trans('courses.new_dashboard.webinars')"
      :completed="progress.webinar.completed"
      :total="progress.webinar.count"
      :infoText="
        trans('courses.new_dashboard.have_completed_webinars', {
          completedWebinars_num: progress.webinar.completed,
          totalWebinars_num: progress.webinar.count,
        })
      "
      type="webinar"
      :is-loading="isLoading"
    />
    <chapters-progress
      v-if="progress.softskill.count"
      :title="trans('courses.new_dashboard.soft_skills')"
      :completed="progress.softskill.completed"
      :total="progress.softskill.count"
      :info-text="
        trans('courses.new_dashboard.have_completed_skills', {
          completedSkills_num: progress.softskill.completed,
          totalSkills_num: progress.softskill.count,
        })
      "
      :is-loading="isLoading"
      type="trophy"
    />
  </user-progress>
</template>

<script>
import UserProgress from "../../molecules/UserProgress";
import DashboardCard from "../../molecules/DashboardCard";
import ChaptersProgress from "../../molecules/ChaptersProgress";

export default {
  name: "StreamProgress",
  components: {
    UserProgress,
    DashboardCard,
    ChaptersProgress,
  },
  props: {
    progress: Object,
    isLoading: Boolean,
  },
};
</script>
